import React, { ComponentProps, ReactElement } from "react";
import { TableTbodyProps } from "./Table.types";
import { Layout, InfiniteScroll } from "./Tbody.styles";

// We need to explicitly type the InfiniteScrollProps to handle the loader prop correctly
interface InfiniteScrollProps
  extends Omit<ComponentProps<typeof InfiniteScroll>, "loader"> {
  loader?: ReactElement | undefined;
}

/**
 * Table body component with infinite scrolling capability
 */
export const Tbody = ({
  className,
  height,
  hasMore,
  loadMore,
  onScroll,
  children,
  loader,
  threshold,
  ...infiniteScrollProps
}: TableTbodyProps) => (
  <Layout onScroll={onScroll} height={height} className={className}>
    <InfiniteScroll
      loadMore={loadMore || (() => {})}
      hasMore={hasMore}
      useWindow={false}
      tabIndex={0}
      threshold={threshold}
      loader={loader as ReactElement | undefined} // Cast to expected type
      {...infiniteScrollProps}
    >
      {children}
    </InfiniteScroll>
  </Layout>
);

export const MemoizedTbody = React.memo(Tbody);
